export default {"src":"/_next/static/media/policy-assessment.cb25a40e.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};